import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  'region': {
    title: '省份',
    type: 'select',
    equation: city,
    dictionary: 'region'
  },
  'city': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'sale': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'sale'
  },
  'customer': {
    title: '经销商',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '经销商选择'
    }
  },
  'brand_bq': {
    title: '品牌',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  },
  'cust_name': {
    title: 'KA计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002'
  },
  'customer_type': {
    title: '年份',
    equation: city,
    type: 'year'
  }
}

export default {
  'saleCenter': { title: '营销中心' },
  'saleCenter1': { title: '省份' },
  'saleCenter2': { title: '计划类型' },
  'saleCenter3': { title: '产品分类' },
  'saleCenter4': { title: '客户编码' },
  'saleCenter5': { title: '经销商名称' },
  'saleCenter6': { title: '卖场全称' },
  'saleCenter7': { title: '计划类型' }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/transferWarehouseKADeliveryPlanReportForms.js